import React from 'react';
import type { DietTypes, Language } from '../types';
import { getTranslation } from '../utils/translations';
import { DIET_TYPE_CONFIG } from '../utils/dietTypes';

interface DietTypesSelectorProps {
    value: DietTypes;
    onChange: (next: DietTypes) => void;
    language?: Language;
    disabled?: boolean;
}

const DietTypesSelector: React.FC<DietTypesSelectorProps> = ({
    value,
    onChange,
    language = 'en',
    disabled = false,
}) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);

    return (
        <div className="flex flex-wrap gap-2">
            {DIET_TYPE_CONFIG.map(({ key, labelKey, emoji }) => {
                const active = value[key];
                return (
                    <button
                        key={key}
                        type="button"
                        disabled={disabled}
                        onClick={() => onChange({ ...value, [key]: !value[key] })}
                        className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-black uppercase tracking-wider transition-all border disabled:opacity-50
                            ${active
                                ? 'bg-brand-sage/10 text-brand-sage border-brand-sage shadow-sm'
                                : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border-slate-200 dark:border-slate-700 hover:border-slate-300'
                            }`}
                    >
                        <span className="text-sm leading-none">{emoji}</span>
                        {t(labelKey)}
                    </button>
                );
            })}
        </div>
    );
};

export default DietTypesSelector;
